

export const athkarEsbahWMasaa = {
  value: 0,
  data: [
    {

      id: 1, content: "اللّهُ لاَ إِلَـهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلاَّ بِمَا شَاء وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيم (255) [آية الكرسى - البقرة].",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "all",
      quran: true
    },

    {
      id: 2, content: " آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ كُلٌّ آمَنَ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ وَقَالُوا سَمِعْنَا وَأَطَعْنَا غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ (285) لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِنْ قَبْلِنَا رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ (286) [البقرة] ",
      repeat: 1,
      info: "عن أَبي مسعودٍ البدْرِيِّ «عن النبيِّ ﷺ قَالَ: منْ قَرَأَ بالآيتَيْنِ مِنْ آخِرِ سُورةِ البقَرةِ فِي لَيْلَةٍ كَفَتَاهُ» متفقٌ عَلَيْهِ.  تقال بعد الغروب وليس قبل غروب الشمس",
      showInfo: false,
      type: "masaa",
      quran: true
    },
    {

      id: 3, content: `
         بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
       قُلۡ هُوَ ٱللَّهُ أَحَدٌ (1)
       ٱللَّهُ ٱلصَّمَدُ (2) 
       لَمۡ يَلِدۡ وَلَمۡ يُولَدۡ (3)
        وَلَمۡ يَكُن لَّهُۥ كُفُوًا أَحَدُۢ (4)`,
      repeat: 3,
      info: " عن عبد الله بن خبيب رضي الله عنه قال: «قال رسولُ اللهِ ﷺ: خَرَجْنا في ليلةِ مَطَرٍ وظُلْمةٍ شديدةٍ نَطْلُبُ رسولَ اللهِ ﷺ، فأَدْرَكْناهُ، فقال : قُلْ، قلتُ : ما أقولُ ؟ ! قال : { قُلْ هُوَ اللهُ أَحَدٌ } ؛ والمَعُوذَتَيْنِ، حين تُصْبِحُ وحين تُمْسِي ثلاثَ مراتٍ ؛ تَكْفِيكَ من كلِّ شيءٍ»",
      showInfo: false,
      type: "all",
      quran: true
    },
    {
      id: 4, content: `
           بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ أَعُوذُ بِرَبِّ ٱلۡفَلَقِ (1) مِن شَرِّ مَا خَلَقَ (2) وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ (3) وَمِن شَرِّ ٱلنَّفَّٰثَٰتِ فِي ٱلۡعُقَدِ (4) وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ (5)
      `,
      repeat: 3,
      info: " عن عبد الله بن خبيب رضي الله عنه قال: «قال رسولُ اللهِ ﷺ: خَرَجْنا في ليلةِ مَطَرٍ وظُلْمةٍ شديدةٍ نَطْلُبُ رسولَ اللهِ ﷺ، فأَدْرَكْناهُ، فقال : قُلْ، قلتُ : ما أقولُ ؟ ! قال : { قُلْ هُوَ اللهُ أَحَدٌ } ؛ والمَعُوذَتَيْنِ، حين تُصْبِحُ وحين تُمْسِي ثلاثَ مراتٍ ؛ تَكْفِيكَ من كلِّ شيءٍ»",
      showInfo: false,
      type: "all",
      quran: true,
    },

    {
      id: 5, content: `
      
           بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ أَعُوذُ بِرَبِّ ٱلنَّاسِ (1) مَلِكِ ٱلنَّاسِ (2) إِلَٰهِ ٱلنَّاسِ (3) مِن شَرِّ ٱلۡوَسۡوَاسِ ٱلۡخَنَّاسِ (4) ٱلَّذِي يُوَسۡوِسُ فِي صُدُورِ ٱلنَّاسِ (5) مِنَ ٱلۡجِنَّةِ وَٱلنَّاسِ (6)
      
      `,
      repeat: 3,
      info: " عن عبد الله بن خبيب رضي الله عنه قال: «قال رسولُ اللهِ ﷺ: خَرَجْنا في ليلةِ مَطَرٍ وظُلْمةٍ شديدةٍ نَطْلُبُ رسولَ اللهِ ﷺ، فأَدْرَكْناهُ، فقال : قُلْ، قلتُ : ما أقولُ ؟ ! قال : { قُلْ هُوَ اللهُ أَحَدٌ } ؛ والمَعُوذَتَيْنِ، حين تُصْبِحُ وحين تُمْسِي ثلاثَ مراتٍ ؛ تَكْفِيكَ من كلِّ شيءٍ»",
      showInfo: false,
      type: "all",
      quran: true
    },
    {
      id: 6, content: "أَصْـبَحْنا وَأَصْـبَحَ المُـلْكُ لله وَالحَمدُ لله، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْـد، وهُوَ على كلّ شَيءٍ قدير، رَبِّ أسْـأَلُـكَ خَـيرَ ما في هـذا اليوم وَخَـيرَ ما بَعْـدَه، وَأَعـوذُ بِكَ مِنْ شَـرِّ ما في هـذا اليوم وَشَرِّ ما بَعْـدَه، رَبِّ أَعـوذُبِكَ مِنَ الْكَسَـلِ وَسـوءِ الْكِـبَر، رَبِّ أَعـوذُ بِكَ مِنْ عَـذابٍ في النّـارِ وَعَـذابٍ في القَـبْر.",
      repeat: 1,
      info: "حديث عبدالله بن مسعودٍ  قال: «كانَ نَبِيُّ اللهِ ﷺ، إذَا أَمْسَى قالَ: أَمْسَيْنَا وَأَمْسَى المُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ لا إلَهَ إلَّا اللَّهُ، وَحْدَهُ لا شَرِيكَ له قالَ: أُرَاهُ قالَ فِيهِنَّ: له المُلْكُ وَلَهُ الحَمْدُ وَهوعلَى كُلِّ شيءٍ قَدِيرٌ، رَبِّ أَسْأَلُكَ خَيْرَ ما في هذِه اللَّيْلَةِ وَخَيْرَ ما بَعْدَهَا، وَأَعُوذُ بكَ مِن شَرِّ ما في هذِه اللَّيْلَةِ وَشَرِّ ما بَعْدَهَا، رَبِّ أَعُوذُ بكَ مِنَ الكَسَلِ وَسُوءِ الكِبَرِ، رَبِّ أَعُوذُ بكَ مِن عَذَابٍ في النَّارِ وَعَذَابٍ في القَبْرِ وإذَا أَصْبَحَ قالَ ذلكَ أَيْضًا: أَصْبَحْنَا وَأَصْبَحَ المُلْكُ لِلَّهِ...، إلى آخره».",
      showInfo: false,
      type: "sabah",
      quran: false
    },

    {
      id: 7, content:  "أَمْسَيْـنا وَأَمْسـى المـلكُ لله وَالحَمدُ لله، لا إلهَ إلاّ اللّهُ وَحدَهُ لا شَريكَ لهُ، لهُ المُـلكُ ولهُ الحَمْـد، وهُوَ على كلّ شَيءٍ قدير، رَبِّ أسْـأَلُـكَ خَـيرَ ما في هـذهِ اللَّـيْلَةِ وَخَـيرَ ما بَعْـدَهـا، وَأَعـوذُ بِكَ مِنْ شَـرِّ ما في هـذهِ اللَّـيْلةِ وَشَرِّ ما بَعْـدَهـا، رَبِّ أَعـوذُبِكَ مِنَ الْكَسَـلِ وَسـوءِ الْكِـبَر، رَبِّ أَعـوذُ بِكَ مِنْ عَـذابٍ في النّـارِ وَعَـذابٍ في القَـبْر.",
      repeat: 1,
      info: "حديث عبدالله بن مسعودٍ  قال: «كانَ نَبِيُّ اللهِ ﷺ، إذَا أَمْسَى قالَ: أَمْسَيْنَا وَأَمْسَى المُلْكُ لِلَّهِ، وَالْحَمْدُ لِلَّهِ لا إلَهَ إلَّا اللَّهُ، وَحْدَهُ لا شَرِيكَ له قالَ: أُرَاهُ قالَ فِيهِنَّ: له المُلْكُ وَلَهُ الحَمْدُ وَهوعلَى كُلِّ شيءٍ قَدِيرٌ، رَبِّ أَسْأَلُكَ خَيْرَ ما في هذِه اللَّيْلَةِ وَخَيْرَ ما بَعْدَهَا، وَأَعُوذُ بكَ مِن شَرِّ ما في هذِه اللَّيْلَةِ وَشَرِّ ما بَعْدَهَا، رَبِّ أَعُوذُ بكَ مِنَ الكَسَلِ وَسُوءِ الكِبَرِ، رَبِّ أَعُوذُ بكَ مِن عَذَابٍ في النَّارِ وَعَذَابٍ في القَبْرِ وإذَا أَصْبَحَ قالَ ذلكَ أَيْضًا: أَصْبَحْنَا وَأَصْبَحَ المُلْكُ لِلَّهِ...، إلى آخره».",
      showInfo: false,
      type: "masaa",
      quran: false
    },
    {
      id: 8, content: 
      "اللّهـمَّ أَنْتَ رَبِّـي لا إلهَ إلاّ أَنْتَ، خَلَقْتَنـي وَأَنا عَبْـدُك، وَأَنا عَلـى عَهْـدِكَ وَوَعْـدِكَ ما اسْتَـطَعْـت، أَعـوذُبِكَ مِنْ شَـرِّ ما صَنَـعْت، أَبـوءُ لَـكَ بِنِعْـمَتِـكَ عَلَـيَّ وَأَبـوءُ بِذَنْـبي فَاغْفـِرْ لي فَإِنَّـهُ لا يَغْـفِرُ الذُّنـوبَ إِلاّ أَنْتَ.",
      repeat: 1,
      info: 
      "عن شداد بن أوس رضي الله عنه عن النبي ﷺ قال: «سَيِّدُ الِاسْتِغْفارِ أنْ تَقُولَ: اللَّهُمَّ أنْتَ رَبِّي لا إلَهَ إلَّا أنْتَ، خَلَقْتَنِي وأنا عَبْدُكَ، وأنا علَى عَهْدِكَ ووَعْدِكَ ما اسْتَطَعْتُ، أعُوذُ بكَ مِن شَرِّ ما صَنَعْتُ، أبُوءُ لكَ بنِعْمَتِكَ عَلَيَّ، وأَبُوءُ لكَ بذَنْبِي فاغْفِرْ لِي؛ فإنَّه لا يَغْفِرُ الذُّنُوبَ إلَّا أنْتَ. قالَ: ومَن قالَها مِنَ النَّهارِ مُوقِنًا بها، فَماتَ مِن يَومِهِ قَبْلَ أنْ يُمْسِيَ، فَهومِن أهْلِ الجَنَّةِ، ومَن قالَها مِنَ اللَّيْلِ وهومُوقِنٌ بها، فَماتَ قَبْلَ أنْ يُصْبِحَ، فَهومِن أهْلِ الجَنَّةِ»  أخرجه البخاري",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 9, content: "رَضيـتُ بِاللهِ رَبَّـاً وَبِالإسْلامِ ديـناً وَبِمُحَـمَّدٍ ﷺ نَبِيّـاً.",
      repeat: 3,
      info: " عن أبي سَلَّامٍ قال: كُنَّا قُعودًا في مَسجِدِ حِمصَ، إذ مَرَّ رَجُلٌ فقالوا: هذا خَدَمَ رسولَ اللهِ صلَّى اللهُ عليه وسلَّمَ، قال: فنَهَضتُ فسَأَلتُه فقُلتُ: حَدِّثْنا بما سَمِعتَ من رسولِ اللهِ صلَّى اللهُ عليه وسلَّمَ لم يَتَداوَلْه الرِّجالُ فيما بيْنَكما، قال: سَمِعتُ رسولَ اللهِ صلَّى اللهُ عليه وسلَّمَ يقولُ: ما مِن عبدٍ مُسلِمٍ يقولُ ثلاثَ مرَّاتٍ حين يُمْسي أويُصبِحُ: رَضيتُ باللهِ رَبًّا، وبالإسلامِ دِينًا، وبمُحمَّدٍ نبيًّا؛ إلَّا كان حقًّا على اللهِ أنْ يُرضِيَه يَومَ القيامةِ. في الحديث الصحيح يقول ﷺ: من قال: «رَضيتُ باللَّهِ ربًّا، وبالإسلامِ دينًا، وبِمُحمَّدٍ رسولًا، وجَبت لَهُ الجنَّةُ»",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 10, content: "اللّهُـمَّ إِنِّـي أَصْبَـحْتُ أُشْـهِدُك، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك، وَمَلَائِكَتَكَ، وَجَمـيعَ خَلْـقِك، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلاّ أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك، وَأَنَّ ُ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك.",
      repeat: 4,
      info: "عن أنس بن مالك: أن رسول الله ﷺ قال: «من قال حين يصبحُ أويمسي: اللهمَّ إني أصبحتُ أشهدُكَ وأشهدُ حملةَ عرشِكَ، وملائكتَكَ وجميعَ خلقِك بأنَّك أنت اللهُ لا إلهَ إلا أنتَ وحدك لا شريكَ لك، وأنَّ محمَّدًا عبدُك ورسولُك أعتقَ اللهُ ربُعَه من النَّارِ، ومن قالها مرَّتين أعتقَ اللهُ نصفَه من النَّارِ، ومن قالها ثلاثًا أعتقَ اللهُ ثلاثةَ أرباعِه من النَّارِ، فإن قالها أربعًا أعتقَه اللهُ من النَّارِ»",
      showInfo: false,
      type: "sabah",
      quran: false
    },

    {
      id: 11, content: "اللّهُـمَّ إِنِّـي أَمسيتُ أُشْـهِدُك، وَأُشْـهِدُ حَمَلَـةَ عَـرْشِـك، وَمَلَائِكَتَكَ، وَجَمـيعَ خَلْـقِك، أَنَّـكَ أَنْـتَ اللهُ لا إلهَ إلاّ أَنْـتَ وَحْـدَكَ لا شَريكَ لَـك، وَأَنَّ ُ مُحَمّـداً عَبْـدُكَ وَرَسـولُـك.",
      repeat: 4,
      info: "عن أنس بن مالك: أن رسول الله ﷺ قال: «من قال حين يصبحُ أويمسي: اللهمَّ إني أصبحتُ أشهدُكَ وأشهدُ حملةَ عرشِكَ، وملائكتَكَ وجميعَ خلقِك بأنَّك أنت اللهُ لا إلهَ إلا أنتَ وحدك لا شريكَ لك، وأنَّ محمَّدًا عبدُك ورسولُك أعتقَ اللهُ ربُعَه من النَّارِ، ومن قالها مرَّتين أعتقَ اللهُ نصفَه من النَّارِ، ومن قالها ثلاثًا أعتقَ اللهُ ثلاثةَ أرباعِه من النَّارِ، فإن قالها أربعًا أعتقَه اللهُ من النَّارِ»",
      showInfo: false,
      type: "masaa",
      quran: false
    },

    {
      id: 12, content: "اللّهُـمَّ ما أَصْبَـَحَ بي مِـنْ نِعْـمَةٍ أَوبِأَحَـدٍ مِـنْ خَلْـقِك، فَمِـنْكَ وَحْـدَكَ لا شريكَ لَـك، فَلَـكَ الْحَمْـدُ وَلَـكَ الشُّكْـر. ",
      repeat: 1,
      info: "",
      // "وعن عبد الله بن غنام قال: قال رسول الله ﷺ  «مَن قالَ حينَ يُصبِحُ: اللَّهمَّ ما أصبحَ بي من نِعمةٍ أوبأحدٍ من خلقِك فمنكَ وحدَك، لا شريكَ لَك، فلَك الحمدُ، ولَك الشُّكرُ، فقد أدَّى شُكرَ يومِه، ومن قالَ مثلَ ذلِك حينَ يُمسي، فقد أدَّى شُكرَ ليلتِه» رواه أبوداود.",
      type: "sabah",
      quran: false
    },
    {
      id: 13, content: "اللّهُـمَّ ما أَمسى بي مِـنْ نِعْـمَةٍ أَوبِأَحَـدٍ مِـنْ خَلْـقِك، فَمِـنْكَ وَحْـدَكَ لا شريكَ لَـك، فَلَـكَ الْحَمْـدُ وَلَـكَ الشُّكْـر. ",
      repeat: 1,
      info: "",
      // "وعن عبد الله بن غنام قال: قال رسول الله ﷺ  «مَن قالَ حينَ يُصبِحُ: اللَّهمَّ ما أصبحَ بي من نِعمةٍ أوبأحدٍ من خلقِك فمنكَ وحدَك، لا شريكَ لَك، فلَك الحمدُ، ولَك الشُّكرُ، فقد أدَّى شُكرَ يومِه، ومن قالَ مثلَ ذلِك حينَ يُمسي، فقد أدَّى شُكرَ ليلتِه» رواه أبوداود.",
      showInfo: false,
      type: "masaa",
      quran: false
    },
    {
      id: 14, content: "حَسْبِـيَ اللّهُ لا إلهَ إلاّ هُوَ عَلَـيهِ تَوَكَّـلتُ وَهُوَ رَبُّ العَرْشِ العَظـيم.",
      repeat: 7,
      info: "",
      // "فقد ورد في حديث رواه ابن السني مرفوعاً وأبوداود موقوفاً بلفظ: «من قال حين يصبح وحين يمسي: حسبي الله لا إله إلا هو، عليه توكلت وهورب العرش العظيم... سبع مرات كفاه الله ما أهمه من أمر الدنيا والآخرة. ولكنه حديث ضعيف",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 15, content: "بِسـمِ اللهِ الذي لا يَضُـرُّ مَعَ اسمِـهِ شَيءٌ في الأرْضِ وَلا في السّمـاءِ وَهـوَ السّمـيعُ العَلـيم. ",
      repeat: 3,
      info: "قال رسول الله ﷺ: « ما من عبدٍ يقولُ في صباحِ كلِّ يومٍ ومساءِ كلِّ ليلةٍ بسمِ اللَّهِ الَّذي لا يضرُّ معَ اسمِهِ شيءٌ في الأرضِ ولا في السَّماءِ وَهوَ السَّميعُ العليمُ ثلاثَ مرَّاتٍ إلا لم يضرَّهُ شيءٌ» رواه الترمذي وغيره، وصححه الألباني.",
      showInfo: false,
      type: "all",
      quran: false
    },

    {
      id: 16, content: "اللّهُـمَّ بِكَ أَصْـبَحْنا وَبِكَ أَمْسَـينا، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ النُّـشُور. ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "sabah",
      quran: false
    },
    {
      id: 17, content: "اللّهُـمَّ بِكَ أَمْسَـينا وَبِكَ أَصْـبَحْنا، وَبِكَ نَحْـيا وَبِكَ نَمُـوتُ وَإِلَـيْكَ الْمَصِيرُ. ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "masaa",
      quran: false
    },

    {
      id: 18, content: "أَصْبَـحْـنا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ.",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "sabah",
      quran: false
    },

     {
      id: 19, content: "أَمْسَيْنَا عَلَى فِطْرَةِ الإسْلاَمِ، وَعَلَى كَلِمَةِ الإِخْلاَصِ، وَعَلَى دِينِ نَبِيِّنَا مُحَمَّدٍ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ، وَعَلَى مِلَّةِ أَبِينَا إبْرَاهِيمَ حَنِيفاً مُسْلِماً وَمَا كَانَ مِنَ المُشْرِكِينَ. ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "masaa",
      quran: false
    },

    {
      id: 20, content: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ عَدَدَ خَلْـقِه، وَرِضـا نَفْسِـه، وَزِنَـةَ عَـرْشِـه، وَمِـدادَ كَلِمـاتِـه.",
      repeat: 3,
      info: "",
      showInfo: false,
      type: "sabah",
      quran: false
    },

    {
      id: 21, content: "اللّهُـمَّ عافِـني في بَدَنـي، اللّهُـمَّ عافِـني في سَمْـعي، اللّهُـمَّ عافِـني في بَصَـري، لا إلهَ إلاّ أَنْـتَ. ",
      repeat: 3,
      info: " قلتُ لأبي: يا أبتِ أسمعُك تقولُ كلَّ غداةٍ: اللَّهمَّ عافِني في بدَني اللَّهمَّ عافِني في سَمعي اللَّهمَّ عافني في بصَري لا إلَه إلَّا أنتَ تُكرِّرُها ثلاثًا حينَ تُصبحُ وثلاثًا حين تُمسي فقال: يا بنيَّ سمعتُ رسولَ اللَّهِ صلَّى اللَّهُ علَيهِ وسلَّمَ يدعوبِهنَّ فأنا أحبُّ أن أستَنَّ بسُننِهِ ",
      showInfo: false,
      type: "all",
      quran: false
    },

    {
      id: 22, content: "اللّهُـمَّ إِنّـي أَعـوذُ بِكَ مِنَ الْكُـفر، وَالفَـقْر، وَأَعـوذُ بِكَ مِنْ عَذابِ القَـبْر، لا إلهَ إلاّ أَنْـتَ.",
      repeat: 3,
      info: "",
      showInfo: false,
      type: "all",
      quran: false
    },

    {
      id: 23, content: "اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في الدُّنْـيا وَالآخِـرَة، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ العَـفْوَ وَالعـافِـيةَ في ديني وَدُنْـيايَ وَأهْـلي وَمالـي، اللّهُـمَّ اسْتُـرْ عـوْراتي وَآمِـنْ رَوْعاتـي، اللّهُـمَّ احْفَظْـني مِن بَـينِ يَدَيَّ وَمِن خَلْفـي وَعَن يَمـيني وَعَن شِمـالي، وَمِن فَوْقـي، وَأَعـوذُ بِعَظَمَـتِكَ أَن أُغْـتالَ مِن تَحْتـي. ",
      repeat: 1,
      info: "عن ابن عمر رضي الله عنهما قال: لم يكنْ رسولُ اللهِ صلى الله عليه وسلم يَدَعُ هؤلاء الدعواتِ حينَ يُمسي، وحينَ يُصبِحُ:اللهم إني أسألُك العافيةَ في الدنيا والآخرةِ، اللهم إني أسألُك العفوَ والعافيةَ في ديني ودنياي وأهلي ومالي، اللهم استرْ عورتي وآمنْ روعاتي، اللهم احفظْني مِن بين يديَّ ومن خلفي وعن يميني وعن شمالي ومن فوقي، وأعوذُ بعظمتِك أن أُغتالَ مِن تحتي.",
      showInfo: false,
      type: "all",
      quran: false
    },


    {
      id: 24, content: "يَا حَيُّ يَا قيُّومُ بِرَحْمَتِكَ أسْتَغِيثُ أصْلِحْ لِي شَأنِي كُلَّهُ وَلاَ تَكِلْنِي إلَى نَفْسِي طَـرْفَةَ عَيْنٍ. ",
      repeat: 3,
      info: "عن أنس بن مالك ـ رضي الله عنه ـ قال: «قال رسول الله ﷺ لفاطمة رضي الله عنها: ما يمنعُكِ أن تسمَعي ما أُوصيكِ به ؟ أن تقولي إذا أصبحْتِ وإذا أمسَيتِ: يا حيُّ يا قيُّومُ برحمتِك أستغيثُ، أَصلِحْ لي شأني كلَّه، ولا تَكِلْني إلى نفسي طرفةَ عَيْنٍ». حسنه الألباني.",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 25, content: "أَصْبَـحْـنا وَأَصْبَـحْ المُـلكُ للهِ رَبِّ العـالَمـين، اللّهُـمَّ إِنِّـي أسْـأَلُـكَ خَـيْرَ هـذا الـيَوْم، فَـتْحَهُ، وَنَصْـرَهُ، وَنـورَهُ وَبَـرَكَتَـهُ، وَهُـداهُ، وَأَعـوذُ بِـكَ مِـنْ شَـرِّ ما فـيهِ وَشَـرِّ ما بَعْـدَه.",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "sabah",
      quran: false
    },

    {
      id: 26, content: "أَمْسَيْنا وَأَمْسَى الْمُلْكُ للهِ رَبِّ الْعَالَمَيْنِ، اللَّهُمَّ إِنَّي أسْأَلُكَ خَيْرَ هَذَه اللَّيْلَةِ فَتْحَهَا ونَصْرَهَا، ونُوْرَهَا وبَرَكَتهَا، وَهُدَاهَا، وَأَعُوذُ بِكَ مِنْ شَرِّ مَا فيهِا وَشَرَّ مَا بَعْدَهَا. ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "masaa",
      quran: false
    },
    {
      id: 27, content: "اللّهُـمَّ عالِـمَ الغَـيْبِ وَالشّـهادَةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كـلِّ شَـيءٍ وَمَليـكَه، أَشْهَـدُ أَنْ لا إِلـهَ إِلاّ أَنْت، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي وَمِن شَـرِّ الشَّيْـطانِ وَشِرْكِهِ، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم. ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "all",
      quran: false
    },

    {
      id: 28, content: "أَعـوذُ بِكَلِمـاتِ اللّهِ التّـامّـاتِ مِنْ شَـرِّ ما خَلَـق.",
      repeat: 3,
      info:"",
      //  "وثبت عن رسول الله ﷺ أنه قال: «من نزل منزلا فقال أعوذ بكلمات الله التامات من شر ما خلق، لم يضره شيء حتى يرتحل من منزله ذلك» رواه الإمام مسلم في صحيحه",
      showInfo: false,
      type: "masaa",
      quran: false
    },
    {
      id: 29, content: "اللَّهُمَّ صَلِّ وَسَلِّمْ وَبَارِكْ على نَبِيِّنَا مُحمَّد. ",
      repeat: 10,
      info: "عنْ عبداللَّه بن عمروبن العاص، رضي اللَّه عنْهُمَا أنَّهُ سمِع رسُول اللَّه ﷺ يقُولُ: «مَنْ صلَّى عليَّ صلاَةً، صلَّى اللَّه علَيّهِ بِهَا عشْرًا» رواهُ مسلم.",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 30, content: "اللَّهُمَّ إِنَّا نَعُوذُ بِكَ مِنْ أَنْ نُشْرِكَ بِكَ شَيْئًا نَعْلَمُهُ، وَنَسْتَغْفِرُكَ لِمَا لَا نَعْلَمُهُ. ",
      repeat: 3,
      info: "روى البخاري في الأدب المفرد عن معقل بن يسار قال: انطلقت مع أبي بكر الصديق رضي الله عنه إلى النبي ﷺ فقال: يا أبا بكرٍ، لَلشِّركُ فيكم أخْفى من دبيبِ النَّملِ، والذي نفسي بيدِه لَلشِّركُ أخْفى من دَبيبِ النَّملِ، ألا أدُلُّك على شيءٍ إذا فعلتَه ذهب عنك قليلهُ وكثيرهُ؟ قل: اللَّهمَّ إنِّي أعوذُ بك أن أُشرِكَ بك وأنا أعلمُ، وأستغفِرُك لما لا أَعلمُ. وصححه الألباني.",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 31, content: "اللَّهُمَّ إِنِّي أَعُوذُ بِكَ مِنْ الْهَمِّ وَالْحَزَنِ، وَأَعُوذُ بِكَ مِنْ الْعَجْزِ وَالْكَسَلِ، وَأَعُوذُ بِكَ مِنْ الْجُبْنِ وَالْبُخْلِ، وَأَعُوذُ بِكَ مِنْ غَلَبَةِ الدَّيْنِ، وَقَهْرِ الرِّجَالِ.",
      repeat: 3,
      info:"", 
      // "عن أنس بن مالك رضي الله عنه، وهوفي صحيح البخاري بلفظ: قال أنس: فكنت أسمعه يكثر أن يقول: اللهم إني أعوذ بك من الهم والحزن، والعجز والكسل، والبخل والجبن، وضلع الدين وغلبة الرجال.",
      showInfo: false,
      type: "all",
      quran: false
    },

    {
      id: 32, content: " أَسْتَغْفِرُ اللَّه الَّذِي لاَ إِلَهَ إِلاَّ هُوالحيَّ الْقَيُّومَ وأَتُوبُ إِلَيهِ.",
      repeat: 3,
      info: "عنِ ابْنِ مَسْعُودٍ قَالَ: قَالَ رسُولُ اللَّه ﷺ: منْ قَالَ: أَسْتَغْفِرُ اللَّه الَّذِي لاَ إِلَهَ إِلاَّ هُوالحيَّ الْقَيُّومَ وأَتُوبُ إِلَيهِ، غُفِرَتْ ذُنُوبُهُ وإِنْ كَانَ قَدْ فَرَّ مِنَ الزَّحْفِ ",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 33, content: "يَا رَبِّ، لَكَ الْحَمْدُ كَمَا يَنْبَغِي لِجَلَالِ وَجْهِكَ، وَلِعَظِيمِ سُلْطَانِكَ.",
      repeat: 3,
      info: "",
      showInfo: false,
      type: "all",
      quran: false
    },

    {
      id: 34, content: " لَا إلَه إلّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلِّ شَيْءِ قَدِيرِ.",
      repeat: 100,
      info: "10 في الصباح و10 في المساء والـ 100 في أي وقت من اليوم  وإن قسمها جاز ذلك  وإن قالها في الصباح فهوفي الصحيحين من حديث أبي هريرة رضي الله عنه  أنَّ رَسولَ اللَّهِ ﷺ قالَ: مَن قالَ: لا إلَهَ إلَّا اللَّهُ، وحْدَهُ لا شَرِيكَ له، له المُلْكُ وله الحَمْدُ، وهوعلَى كُلِّ شَيءٍ قَدِيرٌ، في يَومٍ مِئَةَ مَرَّةٍ؛ كانَتْ له عَدْلَ عَشْرِ رِقابٍ، وكُتِبَتْ له مِئَةُ حَسَنَةٍ، ومُحِيَتْ عنْه مِئَةُ سَيِّئَةٍ، وكانَتْ له حِرْزًا مِنَ الشَّيْطانِ يَومَهُ ذلكَ حتَّى يُمْسِيَ، ولَمْ يَأْتِ أحَدٌ بأَفْضَلَ ممَّا جاءَ به، إلَّا أحَدٌ عَمِلَ أكْثَرَ مِن ذلكَ..",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 35, content: "اللّهُـمَّ عالِـمَ الغَـيبِ وَالشّـهادةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كُـلِّ شَـيءٍ وَمَليـكَه، أَشْهـدُ أَنْ لا إِلـهَ إِلاّ أَنْت، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي، وَمِن شَـرِّ الشَّيْـطانِ وَشِـرْكِه، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم",
      repeat: 1,
      info: "عن أبي هريرة رضي الله عنه أن أبا بكرٍ الصديقَ رضي الله عنه قال يا رسولَ اللهِ مرني بكلماتٍ أقولُهُن إذا أصبحتُ وإذا أمسيتُ، قال قل: اللهم فاطرَ السمواتِ والأرضِ عالمَ الغيبِ والشهادةِ ربَّ كلِّ شيءٍ ومليكَه، أشهدُ أن لا إله إلا أنت، أعوذُ بك من شرِّ نفسي، وشرِّ الشيطانِ وشِرْكِه. قال: قلْها إذا أصبحتَ، وإذا أمسيتَ، وإذا أخذتَ مضجعَك وفي رواية وأن أقترِفَ علَى نَفسي سوءً أوأجُرَّهُ إلى مسلِمٍ.",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 36, content: "سُبْحـانَ اللهِ وَبِحَمْـدِهِ. ",
      repeat: 100,
      info: "قال النبي ﷺ: من قال حين يصبح وحين يمسي: سبحان الله وبحمده مائة مرة غفرت خطاياه وإن كانت مثل زبد البحر.",
      showInfo: false,
      type: "all",
      quran: false
    },
    {
      id: 37, content: "أستغفِرُ اللهَ وأتوبُ إليه",
      repeat: 100,
      info:"",
      showInfo: false,
      type: "all",
      quran: false
    },
  ]
}






export const athkarElnom = {
  value: 0,
  data: [

    {
      id: 38, content: "اللّهُ لاَ إِلَـهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلاَّ بِمَا شَاء وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيم (255) [آية الكرسى - البقرة].",
      repeat: 1,
      info: " قَالَ النَّبِيُّ ﷺ: «إِذَا أَوَيْتَ إِلَى فِرَاشِكَ، فَأَقْرَأْ آيَةَ الكُرْسِيِّ اللَّهُ لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ، فَإِنَّهُ لَنْ يَزَالَ عَلَيْكَ مِنَ اللَّهِ حَافِظُ، وَلَا يَقْرَبُكَ شَيْطَانٌ حَتَّى تُصْبِحَ» رواه البخاري ",
      showInfo: false,
      type: "",
      quran: true

    },
    {
      id: 39, content: " آمَنَ الرَّسُولُ بِمَا أُنْزِلَ إِلَيْهِ مِنْ رَبِّهِ وَالْمُؤْمِنُونَ كُلٌّ آمَنَ بِاللَّهِ وَمَلَائِكَتِهِ وَكُتُبِهِ وَرُسُلِهِ لَا نُفَرِّقُ بَيْنَ أَحَدٍ مِنْ رُسُلِهِ وَقَالُوا سَمِعْنَا وَأَطَعْنَا غُفْرَانَكَ رَبَّنَا وَإِلَيْكَ الْمَصِيرُ (285) لَا يُكَلِّفُ اللَّهُ نَفْسًا إِلَّا وُسْعَهَا لَهَا مَا كَسَبَتْ وَعَلَيْهَا مَا اكْتَسَبَتْ رَبَّنَا لَا تُؤَاخِذْنَا إِنْ نَسِينَا أَوْ أَخْطَأْنَا رَبَّنَا وَلَا تَحْمِلْ عَلَيْنَا إِصْرًا كَمَا حَمَلْتَهُ عَلَى الَّذِينَ مِنْ قَبْلِنَا رَبَّنَا وَلَا تُحَمِّلْنَا مَا لَا طَاقَةَ لَنَا بِهِ وَاعْفُ عَنَّا وَاغْفِرْ لَنَا وَارْحَمْنَا أَنْتَ مَوْلَانَا فَانْصُرْنَا عَلَى الْقَوْمِ الْكَافِرِينَ (286) [البقرة] ",
      repeat: 1,
      info: "قَالَ النَّبِيُّ ﷺ: «الْآيَتَانِ مِنْ آخِرِ سُورَةِ البَقَرَةِ، مَنْ قَرَأَهُمَا فِي لَيْلَةٍ كَفَتَاهُ» متفق عليه.",
      showInfo: false,
      type: "",
      quran: true
    },
    {
      id: 40, content: `
      يجمع كفيه ثم ينفث فيهما فيقول
      break
         بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ هُوَ ٱللَّهُ أَحَدٌ (1)
      ٱللَّهُ ٱلصَّمَدُ (2) 
      لَمۡ يَلِدۡ وَلَمۡ يُولَدۡ (3)
      وَلَمۡ يَكُن لَّهُۥ كُفُوًا أَحَدُۢ (4)  
      break
      break
         بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ أَعُوذُ بِرَبِّ ٱلۡفَلَقِ (1)
      مِن شَرِّ مَا خَلَقَ (2) وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ (3)
      وَمِن شَرِّ ٱلنَّفَّٰثَٰتِ فِي ٱلۡعُقَدِ (4)
      وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ (5)
      break
      break
         بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ أَعُوذُ بِرَبِّ ٱلنَّاسِ (1)
      مَلِكِ ٱلنَّاسِ (2)
      إِلَٰهِ ٱلنَّاسِ (3)
      مِن شَرِّ ٱلۡوَسۡوَاسِ ٱلۡخَنَّاسِ (4)
      ٱلَّذِي يُوَسۡوِسُ فِي صُدُورِ ٱلنَّاسِ (5)
      مِنَ ٱلۡجِنَّةِ وَٱلنَّاسِ (6)
      break
      ثُمَّ يَمْسَحُ بِهِمَا مَا اسْتَطَاعَ مِنْ جَسَدِهِ
      يبدأ  بِهِمَا عَلَى رَأْسِهِ وَوَجْهِهِ وَمَا أَقْبَلَ مِنْ جَسَدِهِ
      `,
      repeat: 3,
      info: " كَانَ النَّبِيُّ ﷺ: «إِذَا أَوَى إِلَى فِرَاشِهِ كُلَّ لَيْلَةٍ: جَمَعَ كَفَّيْهِ، ثُمَّ نَفَثَ فِيهِمَا، فَقَرَأَ فِيهِمَا: قُلْ هُوَ اللَّهُ أَحَدُ، وَقُلْ أَعُوذُ بِرَبِّ الْفَلَقِ، وَ قُلْ أَعُوذُ بِرَبِّ النَّاسِ، ثُمَّ يَمْسَحُ بِهِمَا مَا اسْتَطَاعَ مِنْ جَسَدِهِ، يبدأ  بِهِمَا عَلَى رَأْسِهِ وَوَجْهِهِ وَمَا أَقْبَلَ مِنْ جَسَدِهِ يَفْعَلُ ذَلِكَ ثَلَاثَ مَرَّاتٍ» رواه البخاري ",
      showInfo: false,
      type: "",
      quran: true
    },
    {

      id: 41, content: "بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا.",
      repeat: 1,
      info: "  كَانَ النَّبِيُّ ﷺ إِذَا أَرَادَ أَنْ يَنَامَ قَالَ: بِاسْمِكَ اللَّهُمَّ أَمُوتُ وَأَحْيَا» رواه البخاري",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 42, content: "يَنْفُضْ بهَا فِرَاشَهُ، وَلْيُسَمِّ اللَّهَ، فإنَّه لا يَعْلَمُ ما خَلَفَهُ بَعْدَهُ علَى فِرَاشِهِ، فَإِذَا أَرَادَ أَنْ يَضْطَجِعَ، فَلْيَضْطَجِعْ علَى شِقِّهِ الأيْمَنِ، وَلْيَقُلْ: سُبْحَانَكَ اللَّهُمَّ رَبِّي بكَ وَضَعْتُ جَنْبِي، وَبِكَ أَرْفَعُهُ، إنْ أَمْسَكْتَ نَفْسِي، فَاغْفِرْ لَهَا، وإنْ أَرْسَلْتَهَا فَاحْفَظْهَا بما تَحْفَظُ به عِبَادَكَ الصَّالِحِينَ. وفي روايةٍ: بهذا الإسْنَادِ، وَقالَ: ثُمَّ لْيَقُلْ: باسْمِكَ رَبِّي وَضَعْتُ جَنْبِي، فإنْ أَحْيَيْتَ نَفْسِي، فَارْحَمْهَا",
      repeat: 1,
      info: "عن أبي هريرة أن رسول الله ﷺ قال: «إِذَا أَوَى أَحَدُكُمْ إلى فِرَاشِهِ، فَلْيَأْخُذْ دَاخِلَةَ إِزَارِهِ، فَلْيَنْفُضْ بهَا فِرَاشَهُ، وَلْيُسَمِّ اللَّهَ، فإنَّه لا يَعْلَمُ ما خَلَفَهُ بَعْدَهُ علَى فِرَاشِهِ، فَإِذَا أَرَادَ أَنْ يَضْطَجِعَ، فَلْيَضْطَجِعْ علَى شِقِّهِ الأيْمَنِ، وَلْيَقُلْ: سُبْحَانَكَ اللَّهُمَّ رَبِّي بكَ وَضَعْتُ جَنْبِي، وَبِكَ أَرْفَعُهُ، إنْ أَمْسَكْتَ نَفْسِي، فَاغْفِرْ لَهَا، وإنْ أَرْسَلْتَهَا فَاحْفَظْهَا بما تَحْفَظُ به عِبَادَكَ الصَّالِحِينَ. وفي روايةٍ: بهذا الإسْنَادِ، وَقالَ: ثُمَّ لْيَقُلْ: باسْمِكَ رَبِّي وَضَعْتُ جَنْبِي، فإنْ أَحْيَيْتَ نَفْسِي، فَارْحَمْهَا» صحيح مسلم",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 43, content: "اللهُمَّ خَلَقْتَ نَفْسِي وَأَنْتَ تَوَفَّاهَا، لَكَ مَمَاتُهَا وَمَحْيَاهَا، إِنْ أَحْيَيْتَهَا فَاحْفَظْهَا، وَإِنْ أَمَتَّهَا فَاغْفِرْ لَهَا، اللهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَة.",
      repeat: 1,
      info: "عَنْ عَبْدِ اللهِ بْنِ عُمَرَ أَنَّهُ أَمَرَ رَجُلًا إِذَا أَخَذَ مَضْجَعَهُ قَالَ: «اللهُمَّ خَلَقْتَ نَفْسِي وَأَنْتَ تَوَفَّاهَا، لَكَ مَمَاتُهَا وَمَحْيَاهَا، إِنْ أَحْيَيْتَهَا فَاحْفَظْهَا، وَإِنْ أَمَتَّهَا فَاغْفِرْ لَهَا، اللهُمَّ إِنِّي أَسْأَلُكَ الْعَافِيَةَ» فَقَالَ لَهُ رَجُلٌ: أَسَمِعْتَ هَذَا مِنْ عُمَرَ؟ فَقَالَ: مِنْ خَيْرٍ مِنْ عُمَرَ، مِنْ رَسُولِ اللهِ صَلَّى اللهُ عَلَيْهِ وَسَلَّمَ. صحيح مسلم",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 44, content: "للّهُـمَّ قِنـي عَذابَـكَ يَـوْمَ تَبْـعَثُ عِبـادَك.",
      repeat: 3,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 45, content: "الـحَمْدُ للهِ الَّذي أَطْـعَمَنا وَسَقـانا، وَكَفـانا، وَآوانا، فَكَـمْ مِمَّـنْ لا كـافِيَ لَـهُ وَلا مُـؤْوي. ",
      repeat: 1,
      info: "عن أنس رضي الله عنه أن رسول الله ﷺ كان إذا أوى إلى فراشه، قال: «الـحَمْدُ للهِ الَّذي أَطْـعَمَنا وَسَقـانا، وَكَفـانا، وَآوانا، فَكَمْ مِمَّنْ لا كَافِيَ له وَلاَ مُؤْوِيَ رواه مسلم»",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 46, content: "اللّهُـمَّ عالِـمَ الغَـيبِ وَالشّـهادةِ فاطِـرَ السّماواتِ وَالأرْضِ رَبَّ كُـلِّ شَـيءٍ وَمَليـكَه، أَشْهـدُ أَنْ لا إِلـهَ إِلاّ أَنْت، أَعـوذُ بِكَ مِن شَـرِّ نَفْسـي، وَمِن شَـرِّ الشَّيْـطانِ وَشِـرْكِه، وَأَنْ أَقْتَـرِفَ عَلـى نَفْسـي سوءاً أَوْ أَجُـرَّهُ إِلـى مُسْـلِم",
      repeat: 1,
      info: "عن أبي هريرة رضي الله عنه أن أبا بكرٍ الصديقَ رضي الله عنه قال يا رسولَ اللهِ مرني بكلماتٍ أقولُهُن إذا أصبحتُ وإذا أمسيتُ، قال قل: اللهم فاطرَ السمواتِ والأرضِ عالمَ الغيبِ والشهادةِ ربَّ كلِّ شيءٍ ومليكَه، أشهدُ أن لا إله إلا أنت، أعوذُ بك من شرِّ نفسي، وشرِّ الشيطانِ وشِرْكِه. قال: قلْها إذا أصبحتَ، وإذا أمسيتَ، وإذا أخذتَ مضجعَك وفي رواية وأن أقترِفَ علَى نَفسي سوءً أوأجُرَّهُ إلى مسلِمٍ.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 47, content: "سُبْحَانَ اللَّهِ.",
      repeat: 33,
      info: " عن علي رضي الله عنه: «أنَّ فاطِمَةَ عليهما السَّلامُ شَكَتْ ما تَلْقَى في يَدِها مِنَ الرَّحَى، فأتَتِ النبيَّ صَلَّى اللهُ عليه وسلَّمَ تَسْأَلُهُ خادِمًا فَلَمْ تَجِدْهُ، فَذَكَرَتْ ذلكَ لِعائِشَةَ، فَلَمَّا جاءَ أخْبَرَتْهُ، قالَ: فَجاءَنا وقدْ أخَذْنا مَضاجِعَنا، فَذَهَبْتُ أقُومُ، فقالَ: مَكانَكِ فَجَلَسَ بيْنَنا حتَّى وجَدْتُ بَرْدَ قَدَمَيْهِ علَى صَدْرِي، فقالَ: ألا أدُلُّكُما علَى ما هوخَيْرٌ لَكُما مِن خادِمٍ؟ إذا أوَيْتُما إلى فِراشِكُما، أوْ أخَذْتُما مَضاجِعَكُما، فَكَبِّرا ثَلاثًا وثَلاثِينَ، وسَبِّحا ثَلاثًا وثَلاثِينَ، واحْمَدا ثَلاثًا وثَلاثِينَ، فَهذا خَيْرٌ لَكُما مِن خادِم». وهذا الحديث رواه الإمام البخاري رحمه الله تعالى في ثلاثة مواضع من كتابه الصحيح أوفي أربعة.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 48, content: "الْحَمْدُ لِلَّهِ. ",
      repeat: 33,
      info: " عن علي رضي الله عنه: «أنَّ فاطِمَةَ عليهما السَّلامُ شَكَتْ ما تَلْقَى في يَدِها مِنَ الرَّحَى، فأتَتِ النبيَّ صَلَّى اللهُ عليه وسلَّمَ تَسْأَلُهُ خادِمًا فَلَمْ تَجِدْهُ، فَذَكَرَتْ ذلكَ لِعائِشَةَ، فَلَمَّا جاءَ أخْبَرَتْهُ، قالَ: فَجاءَنا وقدْ أخَذْنا مَضاجِعَنا، فَذَهَبْتُ أقُومُ، فقالَ: مَكانَكِ فَجَلَسَ بيْنَنا حتَّى وجَدْتُ بَرْدَ قَدَمَيْهِ علَى صَدْرِي، فقالَ: ألا أدُلُّكُما علَى ما هوخَيْرٌ لَكُما مِن خادِمٍ؟ إذا أوَيْتُما إلى فِراشِكُما، أوْ أخَذْتُما مَضاجِعَكُما، فَكَبِّرا ثَلاثًا وثَلاثِينَ، وسَبِّحا ثَلاثًا وثَلاثِينَ، واحْمَدا ثَلاثًا وثَلاثِينَ، فَهذا خَيْرٌ لَكُما مِن خادِم». وهذا الحديث رواه الإمام البخاري رحمه الله تعالى في ثلاثة مواضع من كتابه الصحيح أوفي أربعة.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 49, content: "اللَّهُ أَكْبَرُ.",
      repeat: 34,
      info: " عن علي رضي الله عنه: «أنَّ فاطِمَةَ عليهما السَّلامُ شَكَتْ ما تَلْقَى في يَدِها مِنَ الرَّحَى، فأتَتِ النبيَّ صَلَّى اللهُ عليه وسلَّمَ تَسْأَلُهُ خادِمًا فَلَمْ تَجِدْهُ، فَذَكَرَتْ ذلكَ لِعائِشَةَ، فَلَمَّا جاءَ أخْبَرَتْهُ، قالَ: فَجاءَنا وقدْ أخَذْنا مَضاجِعَنا، فَذَهَبْتُ أقُومُ، فقالَ: مَكانَكِ فَجَلَسَ بيْنَنا حتَّى وجَدْتُ بَرْدَ قَدَمَيْهِ علَى صَدْرِي، فقالَ: ألا أدُلُّكُما علَى ما هوخَيْرٌ لَكُما مِن خادِمٍ؟ إذا أوَيْتُما إلى فِراشِكُما، أوْ أخَذْتُما مَضاجِعَكُما، فَكَبِّرا ثَلاثًا وثَلاثِينَ، وسَبِّحا ثَلاثًا وثَلاثِينَ، واحْمَدا ثَلاثًا وثَلاثِينَ، فَهذا خَيْرٌ لَكُما مِن خادِم». وهذا الحديث رواه الإمام البخاري رحمه الله تعالى في ثلاثة مواضع من كتابه الصحيح أوفي أربعة.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 50, content: "اللَّهُمَّ أَسْلَمْتُ نفِسي إِلَيكَ، وَفَوَّضتُ أَمري إِلَيْكَ، وَأَلَجَأْتُ ظَهرِي إِلَيْكَ، رغبةً ورهْبَةً إِلَيْكَ، لامَلجأَ ولا مَنجى مِنْكَ إِلاَّ إِليكَ، آمنتُ بِكِتَابِكَ الذِي أَنزَلْت، وَبِنَبِيِّكَ الذِي أَرسَلتَ",
      repeat: 1,
      info: "عنِ البرَاءِ بنِ عازِبٍ، رَضِيَ اللَّه عنْهمَا، قَالَ: قَالَ لي رسُولُ اللَّهِ ﷺ: إِذَا أَتَيتَ مَضْجَعَكَ فَتَوضَّأْ وضُوءَكَ لِلصَّلاةِ، ثُمَّ اضْطَجِعْ عَلى شِقِّكَ الأَيمَنِ، وقلْ: اللَّهُمَّ أَسْلَمْتُ نفِسي إِلَيكَ، وَفَوَّضتُ أَمري إِلَيْكَ، وَأَلَجَأْتُ ظَهرِي إِلَيْكَ، رغبةً ورهْبَةً إِلَيْكَ، لامَلجأَ ولا مَنجى مِنْكَ إِلاَّ إِليكَ، آمنتُ بِكِتَابِكَ الذِي أَنزَلْت، وَبِنَبِيِّكَ الذِي أَرسَلتَ، فإِنْ مِتَّ. مِتَّ عَلَى الفِطرةِ، واجْعَلهُنَّ آخِرَ مَا تَقُولُ مُتَّفقٌ عليهِ.",
      showInfo: false,
      type: "",
      quran: false
    },

  ]
}

export const athkarEsalah = {
  value: 0,
  data: [

    {
      id: 51, content: " أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ، اللَّهمَّ أنتَ السَّلامُ ومنكَ السَّلامُ، تَباركتَ يا ذا الجلالِ والإكرامِ.",
      repeat: 1,
      info: "كانَ رَسولُ اللهِ صَلَّى اللَّهُ عليه وسلَّمَ، إذَا انْصَرَفَ مِن صَلَاتِهِ اسْتَغْفَرَ ثَلَاثًا وَقالَ: اللَّهُمَّ أَنْتَ السَّلَامُ وَمِنْكَ السَّلَامُ، تَبَارَكْتَ ذَا الجَلَالِ وَالإِكْرَامِ. قالَ الوَلِيدُ: فَقُلتُ لِلأَوْزَاعِيِّ: كيفَ الاسْتِغْفَارُ؟ قالَ: تَقُولُ: أَسْتَغْفِرُ اللَّهَ، أَسْتَغْفِرُ اللَّهَ. رواه مسلم",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 52, content: "لا إلهَ إلاّ اللّهُ وحدَهُ لا شريكَ لهُ، لهُ المُـلْكُ ولهُ الحَمْد، وهوَ على كلّ شَيءٍ قَدير  ثلاثاً، اللّهُـمَّ لا مانِعَ لِما أَعْطَـيْت، وَلا مُعْطِـيَ لِما مَنَـعْت، وَلا يَنْفَـعُ ذا الجَـدِّ مِنْـكَ الجَـد.",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {

      id: 53, content: "لا إلهَ إلاّ اللّه، وحدَهُ لا شريكَ لهُ، لهُ الملكُ ولهُ الحَمد، وهوَ على كلّ شيءٍ قدير، لا حَـوْلَ وَلا قـوَّةَ إِلاّ بِاللهِ، لا إلهَ إلاّ اللّـه، وَلا نَعْـبُـدُ إِلاّ إيّـاه، لَهُ النِّعْـمَةُ وَلَهُ الفَضْل وَلَهُ الثَّـناءُ الحَـسَن، لا إلهَ إلاّ اللّهُ مخْلِصـينَ لَـهُ الدِّينَ وَلَوْ كَـرِهَ الكـافِرون.",
      repeat: 3,
      info: " عَنْ عبدِاللَّه بن الزُّبَيْرِ رضي اللَّه تَعَالَى عنْهُما أَنَّهُ كَانَ يقُول دُبُرَ كَلِّ صلاةٍ، حينَ يُسَلِّمُ: لاَ إلَه إلاَّ اللَّه وَحْدَهُ لاَ شريكَ لهُ، لهُ الملكُ ولهُ الحَمْدُ، وهُوَ عَلى كُلِّ شيءٍ قَديرٌ، لاَ حوْلَ وَلا قُوَّةَ إلاَّ بِاللَّه، لاَ إلهَ إلاَّ اللَّه، وَلا نَعْبُدُ إلاَّ إيَّاهُ، لهُ النعمةُ، ولَهُ الفضْلُ وَلَهُ الثَّنَاءُ الحَسنُ، لاَ إلهَ إلاَّ اللَّه مُخْلِصِينَ لَهُ الدِّينَ ولوْ كَرِه الكَافرُون. قالَ ابْنُ الزُّبَيْر: وكَان رسولُ اللَّه ﷺ يُهَلِّلُ بِهِنَّ دُبُرَ كُلِّ صَلاةٍ مكتوبة. رواه مسلم.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 54, content: "سُـبْحانَ اللهِ، والحَمْـدُ لله، واللهُ أكْـبَر.",
      repeat: 33,
      info: "عن أبي هريرة رضي الله عنه عن رسول الله ﷺ قال: «مَن سبَّح الله دُبُر كل صلاة ثلاثا وثلاثين، وحَمِد الله ثلاثا وثلاثين، وكَبَّر الله ثلاثا وثلاثين، فتِلك تِسْعَةٌ وتِسْعُونَ، وقال تَمَام المائة: لا إله إلا الله وحْدَه لا شريك له، له المُلك، وله الحَمد، وهوعلى كلِّ شيء قَدِير، غُفِرَت خَطَايَاه، وإن كانت مثل زَبَدِ البَحْرِ» رواه مسلم",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 55, content: "لا إلهَ إلاّ اللّهُ وَحْـدَهُ لا شريكَ لهُ، لهُ الملكُ ولهُ الحَمْد، وهُوَ على كُلّ شَيءٍ قَـدير.",
      repeat: 1,
      info: "عن أبي هريرة رضي الله عنه عن رسول الله ﷺ قال: «مَن سبَّح الله دُبُر كل صلاة ثلاثا وثلاثين، وحَمِد الله ثلاثا وثلاثين، وكَبَّر الله ثلاثا وثلاثين، فتِلك تِسْعَةٌ وتِسْعُونَ، وقال تَمَام المائة: لا إله إلا الله وحْدَه لا شريك له، له المُلك، وله الحَمد، وهوعلى كلِّ شيء قَدِير، غُفِرَت خَطَايَاه، وإن كانت مثل زَبَدِ البَحْرِ» رواه مسلم",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 56, content: `
   
           بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ هُوَ ٱللَّهُ أَحَدٌ (1)
      ٱللَّهُ ٱلصَّمَدُ (2) 
      لَمۡ يَلِدۡ وَلَمۡ يُولَدۡ (3)
      وَلَمۡ يَكُن لَّهُۥ كُفُوًا أَحَدُۢ (4)  
      break
      break
      
           بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ أَعُوذُ بِرَبِّ ٱلۡفَلَقِ (1)
      مِن شَرِّ مَا خَلَقَ (2) وَمِن شَرِّ غَاسِقٍ إِذَا وَقَبَ (3)
      وَمِن شَرِّ ٱلنَّفَّٰثَٰتِ فِي ٱلۡعُقَدِ (4)
      وَمِن شَرِّ حَاسِدٍ إِذَا حَسَدَ (5)
      break
      break
      
           بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
      قُلۡ أَعُوذُ بِرَبِّ ٱلنَّاسِ (1)
      مَلِكِ ٱلنَّاسِ (2)
      إِلَٰهِ ٱلنَّاسِ (3)
      مِن شَرِّ ٱلۡوَسۡوَاسِ ٱلۡخَنَّاسِ (4)
      ٱلَّذِي يُوَسۡوِسُ فِي صُدُورِ ٱلنَّاسِ (5)
      مِنَ ٱلۡجِنَّةِ وَٱلنَّاسِ (6)
      break
      ثلاث مرات بعد صلاتي الفجر والمغرب. ومرة بعد الصلوات الأخرى
      `,
      repeat: 3,
      info: " عن عُقبةَ بنِ عامرٍ، قالَ: أمرَني رسولُ اللَّهِ صلَّى اللَّهُ علَيهِ وسلَّمَ أن أقرأَ بالمعوِّذاتِ دُبُرَ كلِّ صلاةٍ",
      showInfo: false,
      type: "",
      quran: true
    },

    {
      id: 57, content: "    اللّهُ لاَ إِلَـهَ إِلاَّ هُوَ الْحَيُّ الْقَيُّومُ لاَ تَأْخُذُهُ سِنَةٌ وَلاَ نَوْمٌ لَّهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الأَرْضِ مَن ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلاَّ بِإِذْنِهِ يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ وَلاَ يُحِيطُونَ بِشَيْءٍ مِّنْ عِلْمِهِ إِلاَّ بِمَا شَاء وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالأَرْضَ وَلاَ يَؤُودُهُ حِفْظُهُمَا وَهُوَ الْعَلِيُّ الْعَظِيمُ. [آية الكرسى - البقرة 255]  ",
      repeat: 1,
      info: "قال النبي ﷺ: «من قرأ آية الكرسي في دبر كل صلاة مكتوبة لم يمنعه من دخول الجنة إلا أن يموت» رواه النسائي في السنن الكبرى",
      showInfo: false,
      type: "",
      quran: true
    },
    {
      id: 58, content: `لا إلهَ إلاّ اللّهُ وحْـدَهُ لا شريكَ لهُ، لهُ المُلكُ ولهُ الحَمْد، يُحيـي وَيُمـيتُ وهُوَ على كُلّ شيءٍ قدير. 
      break
      عَشْر مَرّات بَعْدَ المَغْرِب والفجر

      `,
      repeat: 10,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 59, content: `اللّهُـمَّ إِنِّـي أَسْأَلُـكَ عِلْمـاً نافِعـاً وَرِزْقـاً طَيِّـباً، وَعَمَـلاً مُتَقَـبَّلاً. 
      break
      بَعْد صَلاةِ الصُّبْحَ
      `,
      repeat: 1,
      info: "عَنْ أُمِّ سَلَمَةَ رَضِيَ اللَّهُ عَنْها: أَنَّ النَّبِيَّ ﷺ كَانَ يَقُولُ إذَا صَلَّى الصُّبْحَ حِينَ يُسَلِّمُ: اللَّهُمَّ إنِّي أَسْأَلُكَ عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلًا مُتَقَبَّلًا. رَوَاهُ أَحْمَدُ، وَابْنُ مَاجَهْ.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 60, content: "   اللهمَّ أعنِّي على ذكرِك وشكرِك وحسنِ عبادَتِك.",
      repeat: 1,
      info: "عن مُعَاذٍ أَنَّ رَسُول اللَّه ﷺ، أَخَذَ بِيَدِهِ وَقالَ: يَا مُعَاذُ واللَّهِ إِنِّي لأُحِبُّكَ، ثُمَّ أُوصِيكَ يَا مُعاذُ لاَ تَدَعنَّ في دُبُرِ كُلِّ صلاةٍ تَقُولُ: اللَّهُم أَعِنِّي عَلَى ذِكْرِكَ وَشُكْرِكَ، وحُسنِ عِبَادتِك.رواه أَبُو داود والنسائي.",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 61, content: `اللَّهُمَّ أَجِرْنِي مِنْ النَّار.
      break 
      سبع مَرّات بَعْدَ المَغْرِب والفجر
    `,
      repeat: 7,
      info:"",
      //  "إذا صلَّيتَ الغداةَ فقُل قبلَ أن تُكلِّم أحدًا: اللَّهُمَّ أجِرني منَ النَّارِ سبعَ مرَّاتٍ، فإنَّكَ إن مِتَّ من يومِكَ كتبَ اللَّهُ لَك جِوارًا منَ النَّارِ، وإذا صلَّيتَ المغرِبَ فقُل مثلَ ذلك، فإنَّكَ إن مِتَّ من ليلتِكَ كتبَ اللَّهُ لَك جوارًا منَ النَّارِ حسنه ابن حجر وضعفه جمع من العلماء",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 62, content: `رَبِّ قِنِي عَذَابَكَ يَومَ تَبْعَثُ -أَوْ تَجْمَعُ- عِبَادَكَ.
      
    `,
      repeat: 1,
      info: "عن البراء بن عازب رضي الله عنه قال:  كُنَّا إذَا صَلَّيْنَا خَلْفَ رَسولِ اللهِ صَلَّى اللَّهُ عليه وسلَّمَ، أَحْبَبْنَا أَنْ نَكُونَ عن يَمِينِهِ، يُقْبِلُ عَلَيْنَا بوَجْهِهِ، قالَ: فَسَمِعْتُهُ يقولُ: رَبِّ قِنِي عَذَابَكَ يَومَ تَبْعَثُ -أَوْ تَجْمَعُ- عِبَادَكَ. صحيح مسلم",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 63, content: " اللَّهمَّ إنِّي أعوذُ بِكَ من البُخلِ، وأعوذُ بِكَ منَ الجبنِ وأعوذُ بِكَ أن أردَّ إلى أرذلِ العمُرِ وأعوذُ بِكَ من فتنةِ الدُّنيا وأعوذُ بِكَ من عذابِ القبرِ.",
      repeat: 1,
      info: " لما ورد من حديث سعد بن أبي وقاص إنَّ رسولَ اللَّهِ صلَّى اللَّهُ عليْهِ وسلَّمَ كانَ يتعوَّذُ بِهِنَّ دبرَ الصَّلاةِ اللَّهمَّ إنِّي أعوذُ بِكَ من البُخلِ، وأعوذُ بِكَ منَ الجبنِ وأعوذُ بِكَ أن أردَّ إلى أرذلِ العمُرِ وأعوذُ بِكَ من فتنةِ الدُّنيا وأعوذُ بِكَ من عذابِ القبرِ فيحتمل أنها  بعد السلام",
      showInfo: false,
      type: "",
      quran: false
    },

  ]
}



export const werdAlthekr = {
  value: 0,
  data: [
    {
      id: 64, content: "سُبْحَانَ اللَّهِ ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },

    {
      id: 65, content: "الْحَمْدُ لِلَّهِ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {

      id: 66, content: "لَا إِلَهَ إِلَّا اللَّهُ ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    }, 
    {

      id: 67, content: "اللَّهُ أَكْبَرُ.",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    }, 
      {

      id: 70, content: "لا حَوْلَ وَلا قُوَّةَ إِلا بِاللَّهِ ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    }, 
    {

      id: 71, content: "الْلَّهُم صَلِّ وَسَلِم وَبَارِك عَلَى سَيِّدِنَا مُحَمَّد",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    }, 
         {

      id: 72, content: "أستغفِرُ اللهَ وأتوبُ إليه",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
      
    {

      id: 73, content: "سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، سُبْحَانَ اللَّهِ الْعَظِيمِ ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {

      id: 74, content: "سُبْحَانَ اللهِ العَظِيمِ وَبِحَمْدِهِ ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "عَنْ أَبي هُريرةَ، قالَ: قالَ رَسُولُ اللَّهِ ﷺ: كَلِمتَانِ خَفِيفَتَانِ عَلى اللِّسانِ، ثَقيِلَتانِ فِي المِيزَانِ، حَبِيبَتَانِ إِلَى الرَّحْمنِ: سُبْحان اللَّهِ وَبِحَمْدِهِ، سُبحانَ اللَّه العظيمِ متفقٌ عليهِ.",
      quran: false
    },
     {

      id: 75, content: "لَا إلَه إلّا اللهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ وَهُوَ عَلَى كُلُّ شَيْءِ قَدِيرِ. ",
      repeat: 100,
      info: "عَنْ أَبي هُريرةَ، رَضِي الْلَّهُ عَنهُ قالَ: أنَّ رسُولَ اللَّه ﷺ قالَ: مَن قالَ في يومٍ مائةَ مرَّةٍ لا إلَهَ إلَّا اللَّهُ وحدَهُ لا شريكَ لَهُ، لَهُ الملكُ ولَهُ الحمدُ وَهوَ على كلِّ شيءٍ قديرٌ، كانَ لَهُ عدلُ عشرِ رقابٍ، وَكُتِبَت لَهُ مائةُ حَسنةٍ، ومُحيَ عنهُ مائةُ سيِّئةٍ، وَكُنَّ لَهُ حِرزًا منَ الشَّيطانِ، سائرَ يومِهِ إلى اللَّيلِ، ولم يأتِ أحدٌ بأفضَلَ ممَّا أتى بِهِ، إلَّا من قالَ أَكْثرَ.",
      showInfo: false,
      type: "",
      quran: false
    },
 
    {

      id: 76, content: "سُبْحَانَ الْلَّهِ، وَالْحَمْدُ لِلَّهِ، وَلَا إِلَهَ إِلَّا الْلَّهُ، وَالْلَّهُ أَكْبَرُ ",
      repeat: 100,
      info: "عَنْ أَبي هُريرةَ، رَضِي الْلَّهُ عَنهُ قالَلَ: قالَ رَسُولُ اللَّه ﷺ: لأَنْ أَقُولَ سبْحانَ اللَّهِ، وَالحَمْدُ للَّهِ، وَلاَ إلَه إلاَّ اللَّه، وَاللَّه أكْبرُ، أَحبُّ إليَّ مِمَّا طَلَعَت عليهِ الشَّمْسُ رواه مسلم.",
      showInfo: false,
      type: "",
      quran: false
    },
    {

      id: 77, content: "سُبْحَانَ اللَّهِ وَالْحَمْدُ لِلَّهِ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    
    {

      id: 78, content: "اللَّهُمَّ صَلِّ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا صَلَّيْتَ عَلَى إِبْرَاهِيمَ،  وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ،اللَّهُمَّ بَارِكْ عَلَى مُحَمَّدٍ وَعَلَى آلِ مُحَمَّدٍ كَمَا بَارَكْتَ عَلَى إِبْرَاهِيمَ وَعَلَى آلِ إِبْرَاهِيمَ إِنَّكَ حَمِيدٌ مَجِيدٌ. ",
      repeat: 100,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    }
  ]
}


export const athkarMudafa = {
  value: 0,
  data: [
   
{
      id: 80, content: `سبحان الله عدد ماخلق
      break
سبحان الله ملئ ما خلق
break
سبحان الله عدد ما في السموات وما في الارض
break
سبحان الله ملئ ما في السموات وما في الارض 
break
سبحان الله عدد كل شيء
break
سبحان الله ملئ كل شيء
break
سبحان الله عدد ما أحصى كتابه
break
سبحان الله ملئ ما أحصى كتابه`,
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 81, content: `الحمد لله عدد ماخلق
      break
الحمد لله ملئ ما خلق
break
الحمد لله عدد ما في السموات وما في الارض
break
الحمد لله ملئ ما في السموات وما في الارض 
break
الحمد لله عدد كل شيء
break
الحمد لله ملئ كل شيء
break
الحمد لله عدد ما أحصى كتابه
break
الحمد لله ملئ ما أحصى كتابه`,
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 82, content: `لا إله إلا الله عدد ماخلق
      break
لا إله إلا الله ملئ ما خلق
break
لا إله إلا الله عدد ما في السموات وما في الارض
break
لا إله إلا الله ملئ ما في السموات وما في الارض 
break
لا إله إلا الله عدد كل شيء
break
لا إله إلا الله ملئ كل شيء
break
لا إله إلا الله عدد ما أحصى كتابه
break
لا إله إلا الله ملئ ما أحصى كتابه`,
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
     {
      id: 83, content: `الله أكبر عدد ماخلق
      break
الله أكبر ملئ ما خلق
break
الله أكبر عدد ما في السموات وما في الارض
break
الله أكبر ملئ ما في السموات وما في الارض 
break
الله أكبر عدد كل شيء
break
الله أكبر ملئ كل شيء
break
الله أكبر عدد ما أحصى كتابه
break
الله أكبر ملئ ما أحصى كتابه`,
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {
      id: 84, content: `لا حول ولا قوة إلا بالله عدد ماخلق
      break
لا حول ولا قوة إلا بالله ملئ ما خلق
break
لا حول ولا قوة إلا بالله عدد ما في السموات وما في الارض
break
لا حول ولا قوة إلا بالله ملئ ما في السموات وما في الارض 
break
لا حول ولا قوة إلا بالله عدد كل شيء
break
لا حول ولا قوة إلا بالله ملئ كل شيء
break
لا حول ولا قوة إلا بالله عدد ما أحصى كتابه
break
لا حول ولا قوة إلا بالله ملئ ما أحصى كتابه`,
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
      

    {

      id: 85, content: "اللهم صل وسلم وبارك على نبينا محمد عدد ما ذكره الذاكرون وغفل عن ذكره الغافلون ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {

      id: 86, content: "اللهم اغفر للمسلمين والمسلمات والمؤمنين والمؤمنات الأحياء منهم والأموات ",
      repeat: 1,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },
    {

      id:87, content: `
         بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
       قُلۡ هُوَ ٱللَّهُ أَحَدٌ (1)
       ٱللَّهُ ٱلصَّمَدُ (2) 
       لَمۡ يَلِدۡ وَلَمۡ يُولَدۡ (3)
        وَلَمۡ يَكُن لَّهُۥ كُفُوًا أَحَدُۢ (4)`,
      repeat: 3,
      info: "",
      showInfo: false,
      type: "all",
      quran: true
    },
    {

      id: 89, content: `
         بِسْمِ اللهِ الرَّحْمنِ الرَّحِيمِ
      break
       قُلۡ هُوَ ٱللَّهُ أَحَدٌ (1)
       ٱللَّهُ ٱلصَّمَدُ (2) 
       لَمۡ يَلِدۡ وَلَمۡ يُولَدۡ (3)
        وَلَمۡ يَكُن لَّهُۥ كُفُوًا أَحَدُۢ (4)`,
      repeat: 10,
      info: "", 
      showInfo: false,
      type: "all",
      quran: true
    },
   {

      id: 91, content: "سبحان الله وبحمده عدد خلقه ورضا نفسه وزنة عرشه ومداد كلماته",
      repeat: 3,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    },{

      id: 92, content: "أستغفر الله الذي لا إله إلا هوالحي القيوم وأتوب إليه",
      repeat: 3,
      info: "",
      showInfo: false,
      type: "",
      quran: false
    }
  ]
}